import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';
@Injectable({
	providedIn: 'root'
})
export class BreakpointService {
	private isXSmallSubject = new BehaviorSubject<boolean>(false);
	private isSmallSubject = new BehaviorSubject<boolean>(false);
	private isMediumSubject = new BehaviorSubject<boolean>(false);
	private isWebLandscapeSubject = new BehaviorSubject<boolean>(false);

	isXSmall$ = this.isXSmallSubject.asObservable();
	isSmall$ = this.isSmallSubject.asObservable();
	isMedium$ = this.isMediumSubject.asObservable();
	isWebLandscape$ = this.isWebLandscapeSubject.asObservable();

	constructor(private breakpointObserver: BreakpointObserver) {
		this.observeBreakpoints();
	}

	private observeBreakpoints() {
		this.breakpointObserver
			.observe([
				Breakpoints.XSmall,
				Breakpoints.Small,
				Breakpoints.Medium,
				Breakpoints.WebLandscape
			])
			.subscribe((result: any) => {
				this.isXSmallSubject.next(result.breakpoints[Breakpoints.XSmall]);
				this.isSmallSubject.next(result.breakpoints[Breakpoints.Small]);
				this.isMediumSubject.next(result.breakpoints[Breakpoints.Medium]);
				this.isWebLandscapeSubject.next(
					result.breakpoints[Breakpoints.WebLandscape]
				);
			});
	}
}
